<div class="color-bar"></div>

<div class="conteudo">
  <div class="container-fluid cartoes" style="background-color: #fff;">
    <div class="row faixa-conteudo pt0">
      <div class="col col-lg-12">
        <div class="caixa">
          <div class="conteudo-caixa-sem-titulo sem-padding">
            <div class="filtro-dash">
              <div>
                <div translate class="filtro ng-star-inserted" style="margin: 10px 22px 0px 0px;">
                  {{'businessIntelligence.indicadorVenda.dealers'}}
                </div>
                <span class="btn btn-outline-info btn-sm" *ngFor="let dealer of filtrosDealers.selecionados()"
                  style="margin: 6px 2px 0px 2px; text-transform: uppercase;" (click)="removerDealer(dealer)">
                  {{dealer.nome}}
                  <i class="fa fa-times" aria-hidden="true" (click)="removerDealer(dealer)"></i>
                </span>
                <div class="botao">
                  <button class="btn btn-info btn-sm" (click)="selecionarDealer()">
                    <em class="fa fa-plus"></em>
                  </button>
                </div>
                <div class="clear"></div>
              </div>
            </div>
            <hr>
            <div class="row ptb50">
              <div class="col col-4">
                <div translate class="filtro ng-star-inserted" style="margin: 0px 10px 0px 0px;">
                  {{'businessIntelligence.indicadorVenda.dataInicial'}}
                </div>
                <p-calendar [(ngModel)]="dataInicial" dateFormat="dd/mm/yy" [showIcon]="true" icon="pi pi-calendar"
                  styleClass="p-iputtext-sm" [style]="{'minWidth':'100%'}" [yearNavigator]="true"
                  (onClearClick)="limpaDataInicial()" [monthNavigator]="true" yearRange="2000:2030"
                  placeholder="{{'businessIntelligence.indicadorVenda.dataInicialPlaceHolder' | translate}}"
                  showButtonBar="true">
                </p-calendar>
              </div>
              <div class="col col-4">
                <div translate class="filtro ng-star-inserted" style="margin: 0px 10px 0px 0px;">
                  {{'businessIntelligence.indicadorVenda.dataFinal'}}
                </div>
                <p-calendar [(ngModel)]="dataFinal" dateFormat="dd/mm/yy" [showIcon]="true" icon="pi pi-calendar"
                  styleClass="p-iputtext-sm" [style]="{'minWidth':'100%'}" (onClearClick)="limpaDataFinal()"
                  placeholder="{{'businessIntelligence.indicadorVenda.dataFinalPlaceHolder' | translate}}"
                  showButtonBar="true" [monthNavigator]="true" [yearNavigator]="true" yearRange="2000:2030">
                </p-calendar>
              </div>
              <div class="col col-4">
                <button translate type="button" class="btn btn-primary mt-3 mr-2" (click)="filtroAPI()">
                  {{'businessIntelligence.indicadorVenda.filtrar'}}
                  <i class="fas fa-search"></i>
                </button>
                <button [class.btn-info]="!getListagemComFiltros()" [class.btn-warning]="getListagemComFiltros()"
                  translate class="btn mt-3" type="button" (click)="exibirFiltro()">
                  {{'businessIntelligence.indicadorVenda.maisFiltros'}}
                  <em class="fa fa-filter"></em>
                </button>
                <button pButton class="p-button-outlined p-button-secondary p-button-sm float-right mt-3" type="button"
                  (click)="exportExcel()">
                  <i class="fa fa-download mr-1"></i>Export Excel
                </button>
              </div>
            </div>
            <hr>
          </div>
        </div>
      </div>
    </div>

    <app-loading [exibir]="carregando"></app-loading>
    <div *ngIf="!carregando">
      <div translate *ngIf="dealersDados?.length <= 0" class="sem-registros text-muted mt-2">
        {{'businessIntelligence.indicadorVenda.nenhumRegistroExibir'}}
      </div>

      <p-table #dt *ngIf="dealersDados?.length > 0" [value]="dealersDados" dataKey="id" selectionMode="single"
        styleClass="p-datatable-responsive-demo p-datatable-striped p-datatable-sm" [columns]="selectedColumns"
        [paginator]="dealersDados?.length > 10" [rows]="10" [columns]="cols" [value]="rows" [autoLayout]="true"
        currentPageReportTemplate="{{'businessIntelligence.indicadorVenda.mostrandoRegistros' | translate}}"
        [showCurrentPageReport]="true" [rowsPerPageOptions]="[10,20,30,50,100]" [globalFilterFields]="['codDealer','nome','data','partNumber',
        'descricaoItem','quantidade','valorVenda','origem','documento','inventFinalQtd']" id="excel-table">
        <ng-template pTemplate="caption">
          <div class="table-header">
            <span class="p-input-icon-left mr-1">
              <i class="pi pi-search"></i>
              <input pInputText type="text" (input)="dt.filterGlobal($event.target.value, 'contains')"
                placeholder="{{'businessIntelligence.indicadorVenda.filtroGeral' | translate}}" />
            </span>

            <p-multiSelect *ngIf="this.translate.currentLang == 'br'" [options]="cols" [(ngModel)]="selectedColumns"
              optionLabel="headerBr"
              selectedItemsLabel="{{'businessIntelligence.indicadorVenda.colunasSelecionadas' | translate}}"
              [style]="{minWidth: '200px'}"
              placeholder="{{'businessIntelligence.indicadorVenda.colunasSelecionadasPlaceHolder' | translate}}">
            </p-multiSelect>
            <p-multiSelect *ngIf="this.translate.currentLang == 'gb'" [options]="cols" [(ngModel)]="selectedColumns"
              optionLabel="headerGb"
              selectedItemsLabel="{{'businessIntelligence.indicadorVenda.colunasSelecionadas' | translate}}"
              [style]="{minWidth: '200px'}"
              placeholder="{{'businessIntelligence.indicadorVenda.colunasSelecionadasPlaceHolder' | translate}}">
            </p-multiSelect>
          </div>
        </ng-template>
        <ng-template pTemplate="header" let-columns>
          <tr>
            <ng-container *ngFor="let col of columns">
              <th *ngIf="col.field == 'detalhe'" [translate]="getTranslate(col.header)" class="text-center"
                style="background-color:black;color:white;">
                {{col.header}}
              </th>
              <th *ngIf="col.field != 'detalhe'" class="text-center" [translate]="getTranslate(col.header)"
                [pSortableColumn]="col.field" style="background-color:black;color:white;">
                {{col.header}}
                <img class="mb-1" width="10" height="10" src="assets/img/imgIconSort.svg" alt="Logo" />
              </th>
            </ng-container>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-dealer let-columns="columns">
          <tr>
            <ng-container *ngFor="let col of columns">
              <td *ngIf="col.field == 'detalhe'" style="padding: 2px;">
                <button class="btn-ver" pTooltip="{{'rmpv.detalhado.verDetalhe' | translate}}"
                  (click)="detalhado(dealer)" style="cursor: pointer;">
                  <img src="assets/img/detail.png" />
                </button>
              </td>
              <td *ngIf="col.field != 'detalhe'" class="text-center">
                <div [ngClass]="{'dealer': col.field === 'nome'}">
                  {{ col.type ? col.type.transform(dealer[col.field], col.arg1) : dealer[col.field] }}
                  <ng-container *ngIf="col.field === 'status'" [translate]="getTranslate(dealer)"></ng-container>
                </div>
              </td>
            </ng-container>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>

<p-dialog header="Definir filtros" [(visible)]="displayFiltros" [style]="{width: '550px'}" [modal]="true"
  [draggable]="false">
  <form [formGroup]="form">
    <div class="container striped-rows">
      <div class="row ptb5">
        <div translate class="col col-4">
          {{'businessIntelligence.indicadorVenda.origem'}}
        </div>
        <div class="col col-8">
          <p-dropdown appendTo="body" placeholder="{{'businessIntelligence.indicadorVenda.origemPlaceHolder' | translate}}" 
            [options]="origem" optionLabel="nome"
            optionValue="valor" formControlName="origem" [autoDisplayFirst]="false" [style]="{'minWidth':'100%'}"
            styleClass="p-inputtext-sm">
          </p-dropdown>
        </div>
      </div>
      <div class="row ptb5">
        <div translate class="col col-4">
          {{'businessIntelligence.indicadorVenda.partNumber'}}
        </div>
        <div class="col col-8">
          <input class="form-control form-control-sm" type="text" placeholder="{{'businessIntelligence.indicadorVenda.partNumberPlaceHolder' | translate}}"
            formControlName="partNumber">
        </div>
      </div>
      <div class="row ptb5">
        <div translate class="col col-4">
          {{'businessIntelligence.indicadorVenda.documento'}}
        </div>
        <div class="col col-8">
          <input class="form-control form-control-sm" type="text" placeholder="{{'businessIntelligence.indicadorVenda.documentoPlaceHolder' | translate}}"
            formControlName="documento">
        </div>
      </div>
      <div class="row ptb5">
        <div class="col col-4">
          Peça Original
        </div>
        <div class="col col-8">
          <select class="form-control form-control-sm" formControlName="original">
            <option value="">Selecione...</option>
            <option value="S">SIM</option>
            <option value="N">NÃO</option>
          </select>
        </div>
      </div>
    </div>
  </form>
  <ng-template pTemplate="footer">
    <button type="button" class="btn btn-outline-primary" (click)="limparFiltros()">
      <i class="fa fa-trash" aria-hidden="true"></i>
    </button>
    <button translate type="button" class="btn btn-info"
      (click)="filtroAPI()">{{'businessIntelligence.indicadorVenda.filtrar'}}</button>
  </ng-template>
</p-dialog>

<p-dialog header="{{'businessIntelligence.indicadorVenda.selecioneDealers' | translate}}"
  [(visible)]="displayFiltrosDealers" [style]="{width: '800px'}" [modal]="true" [draggable]="false">
  <div class="d-flex flex-wrap">
    <ng-container *ngFor="let item of filtrosDealers.naoSelecionados()">
      <span class="btn btn-primary btn-sm itemListaSelecao" style="font-size: 14px; margin: 2px;"
        (click)="onAdicionarDealerFiltro(item)">
        {{item.toTexto()}}
      </span>
    </ng-container>
  </div>
</p-dialog>

<p-toast key="rmpvDetalhado" position="bottom-right"></p-toast>
